export default __webpack_public_path__ + "static/media/CloseDisable.1d1f852c.svg";